import { createContext, useContext, type ReactNode } from "react";
import type { ReferenciasGateway } from "../infrastructure/referencias.gateway";
import { ToastDeSincronizacao } from "../presentation/toast-de-sincronizacao";

const Contexto = createContext<ReferenciasGateway | null>(null);

/**
 * Injecao de dependencia do front.
 *
 * O componente pede o gateway pelo contexto em vez de importar a implementacao
 * HTTP. E o equivalente ao container do NestJS: em producao entra
 * `ReferenciasGatewayHttp`, no teste entra `ReferenciasGatewayEmMemoria`, e o
 * componente nao sabe a diferenca.
 */
export function ProvedorDeReferencias({
  gateway,
  children,
}: {
  readonly gateway: ReferenciasGateway;
  readonly children: ReactNode;
}) {
  return (
    <Contexto.Provider value={gateway}>
      {children}
      <ToastDeSincronizacao />
    </Contexto.Provider>
  );
}

export function useReferenciasGateway(): ReferenciasGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    // Falhar alto: sem isso o erro apareceria como "cannot read property of
    // null" dentro de um hook, longe da causa (o Provider que faltou).
    throw new Error(
      "useReferenciasGateway precisa estar dentro de <ProvedorDeReferencias>.",
    );
  }
  return gateway;
}
